import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../style/footer.css';
import logo from '../../assets/FVOL2.png';

// Import social media icons
import { FaYoutube, FaInstagram, FaLinkedin, FaTwitter, FaFacebookF, FaEnvelope, FaMapMarkerAlt, FaPhone, FaHeart, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  const location = useLocation();

  // FIXED onClick VERSION - DEFINITELY WORKS
  const handleEmailClick = (e) => {
    e.preventDefault();
    // Method 1: Direct assignment
    window.location.href = 'mailto:info@404fxvisuals.com?subject=Inquiry%20from%20404%20FX%20Visuals%20Website&body=Hello%20404%20FX%20Visuals%20Team%2C%0D%0A%0D%0AI%20would%20like%20to%20discuss%20a%20potential%20collaboration.%0D%0A%0D%0AThanks!';
    
    // Method 2: Alternative if the above doesn't work
    // window.open('mailto:info@404fxvisuals.com?subject=Inquiry from Website', '_self');
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/923215416819', '_blank');
  };

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Handle link click with scroll to top
  const handleLinkClick = () => {
    setTimeout(scrollToTop, 100);
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Logo and Description */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img src={logo} alt="404 FX Visuals"  />
            </div>
            <p className="footer-description">
              Creating stunning visual experiences that push creative boundaries and deliver exceptional results for global clients.
            </p>
            <div className="social-links">
              <a href="https://www.instagram.com/404fxvisuals?igsh=OG9reDNldTU0cDlh" className="social-link" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
                <div className="tooltip">
                  <span>Instagram</span>
                  <div className="tooltip-arrow"></div>
                </div>
              </a>
              <a href="https://www.linkedin.com/company/404fxvisuals/about/?viewAsMember=true" className="social-link" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
                <div className="tooltip">
                  <span>LinkedIn</span>
                  <div className="tooltip-arrow"></div>
                </div>
              </a>
              <a href="https://x.com/404fxVisualss" className="social-link" target="_blank" rel="noopener noreferrer">
                <FaTwitter />
                <div className="tooltip">
                  <span>Twitter</span>
                  <div className="tooltip-arrow"></div>
                </div>
              </a>
              <a href="https://www.facebook.com/profile.php?id=61584148853364" className="social-link" target="_blank" rel="noopener noreferrer">
                <FaFacebookF />
                <div className="tooltip">
                  <span>Facebook</span>
                  <div className="tooltip-arrow"></div>
                </div>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h3 className="footer-heading">Navigation</h3>
            <ul className="footer-nav">
              <li>
                <Link to="/" className="footer-link" onClick={handleLinkClick}>
                  <span className="link-arrow">→</span>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="footer-link" onClick={handleLinkClick}>
                  <span className="link-arrow">→</span>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="footer-link" onClick={handleLinkClick}>
                  <span className="link-arrow">→</span>
                  Services
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="footer-link" onClick={handleLinkClick}>
                  <span className="link-arrow">→</span>
                  Portfolio
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="footer-link" onClick={handleLinkClick}>
                  <span className="link-arrow">→</span>
                  Client Reviews
                </Link>
              </li>
              <li>
                <Link to="/packages" className="footer-link" onClick={handleLinkClick}>
                  <span className="link-arrow">→</span>
                  Our Packages
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h3 className="footer-heading">Contact Info</h3>
            <div className="contact-info">
              {/* ONCLICK VERSION - DEFINITELY WORKS */}
              <div 
                className="contact-item" 
                onClick={handleEmailClick}
                style={{ 
                  cursor: 'pointer', 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '1rem' 
                }}
              >
                <FaEnvelope className="contact-iconn" />
                <div className="contact-text">
                  info@404fxvisuals.com
                  <span className="contact-hint">Click to email</span>
                </div>
              </div>
              
              {/* WhatsApp */}
              <div 
                className="contact-item" 
                onClick={handleWhatsAppClick} 
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '1rem' }}
              >
                <FaWhatsapp className="contact-iconn" />
                <div className="contact-text">
                  +92 321 5416819
                  <span className="contact-hint">Click for WhatsApp</span>
                </div>
              </div>
              
              {/* Location */}
              <div className="contact-item" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <FaMapMarkerAlt className="contact-iconn" />
                <div className="contact-text">
                  Model town 47c block C Lahore<br />
                  Pakistan
                </div>
              </div>
            </div>
          </div>

          {/* Google Maps */}
          <div className="footer-map">
            <h3 className="footer-heading">Our Location</h3>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3402.3359541689015!2d74.3220945756103!3d31.487448274229045!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzHCsDI5JzE0LjgiTiA3NMKwMTknMjguOCJF!5e0!3m2!1sen!2s!4v1771604936047!5m2!1sen!2s"
                width="100%"
                height="200"
                style={{ border: 0, borderRadius: '10px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="404 FX Visuals Location"
              ></iframe>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              &copy; 2025 <span className="brand-name">404 FX VISUALS</span>. Made with <FaHeart className="heart-icon" /> All rights reserved.
            </p>
            <div className="footer-legal">
              <Link to="/privacy" className="legal-link" onClick={handleLinkClick}>
                Privacy Policy
              </Link>
              <Link to="/terms" className="legal-link" onClick={handleLinkClick}>
                Terms of Service
              </Link>
              <Link to="/cookies" className="legal-link" onClick={handleLinkClick}>
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;